import { connect } from 'react-redux'
import * as selector from '../../state/state-responsible/selector'
import * as action from '../../state/state-responsible/action'
import StateResponsible from './StateResponsible'
import { selectProcessNameList } from '../../../globals/state/selector'
import { push } from 'connected-react-router'


const mapStateToProps = (state, props) => {
    return {
        stateAnalytics: selector.selectStateAnalytics(state),
        userSelection: selector.selectUserSelection(state),
        processNameList: selectProcessNameList(state),

        // task level
        currentTaskName: selector.selectCurrentTaskName(state),
        taskByDueDateList: selector.selectTaskByDueDateList(state),
        taskList: selector.selectTaskList(state),
        taskTableSetting: selector.selectTaskTableSetting(state),

        // state level
        currentStateName: selector.selectCurrentStateName(state),
        stateByLastChangedList: selector.selectStateByLastChangedList(state),
        processInstanceList: selector.selectProcessInstanceList(state),
        stateTableSetting: selector.selectStateTableSetting(state),
    }
}

const mapDispatchToProps = {
    getStateAnalytics: action.getStateAnalytics,
    getStateLastChanged: action.getStateLastChanged,
    getTaskByDueDate: action.getTaskByDueDate,
    changeUserSelection: action.changeUserSelection,
    findTaskByWeekDiff: action.findTaskByWeekDiff,
    findProcessInstanceByWeekDiff: action.findProcessInstanceByWeekDiff,
    changeTaskTableSetting: action.changeTaskTableSetting,
    changeStateTableSetting: action.changeStateTableSetting,
    navigateToTaskDetail: (taskId) => {
        return push('/task/detail/' + taskId)
    },
    navigateToProcessInstanceDetail: (processInstanceId) => {
        return push('/process/instance/view/' + processInstanceId)
    },
}

export default connect(mapStateToProps, mapDispatchToProps)(StateResponsible)



// WEBPACK FOOTER //
// ./src/modules/analytics/component/state-responsible/StateResponsibleContainer.js